import FooterLinks from "../FooterElements/FooterNetwork"
import { NavLink } from 'react-router-dom'
import { FACEBOOK_URL, INSTAGRAM_URL, WHATSAPP_URL, DEVELOPER_URL, FACEBOOK_MESSENGER_URL } from "../../static/constants/Config"

const FooterContainer = () => {

    const styleHidden = {
        display: 'none'
    }

    const actualYear = new Date().getFullYear()

    return (
        <footer id="fFotter" className="bg-dark text-center text-white footerComponent" data-aos="fade-right">
            <div>
                <div>
                    <FooterLinks urlRedirect={FACEBOOK_URL} socialNetwork={'facebook'} />
                    <FooterLinks urlRedirect={INSTAGRAM_URL} socialNetwork={'instagram'} />
                    <FooterLinks urlRedirect={WHATSAPP_URL} socialNetwork={'whatsapp'} />
                    <FooterLinks urlRedirect={FACEBOOK_MESSENGER_URL} socialNetwork={'messenger'} />
                </div>
            </div>
            <span className="mpk_link_color" style={styleHidden}>
                <NavLink to="./Shop">Tienda </NavLink> |
                <NavLink to="./Productos"> Productos</NavLink> |
                <NavLink to="./Nosotros"> ¿Quienes Somos?</NavLink> |
                <NavLink to="./Testimonios"> Testimonios</NavLink> |
                <NavLink to="./Contacto"> Contacto</NavLink> |
                <NavLink to="./Embajadores"> Embajadores</NavLink>
            </span>
            <p id="pFooterCopy">Copyright (c) {actualYear} MIPEKICHA. Calle Gladiola #106 Fracc. Jardines de Durango, Durango, Durango 34200</p>
            <p className="mpk_link_color">
                <NavLink id="aFooterTerms" to="./Terminos">Terms of Use |
                    Privacy Policy</NavLink>
            </p>
            <p className="mpk_link_color">
                <FooterLinks urlRedirect={DEVELOPER_URL} socialNetwork={'mipekicha'} />
            </p>
        </footer>
    )
}

export default FooterContainer
